import { post, get } from './fetch.js'
export default {
  home: {
    my_trace(params) {
      params.PCTOKEN = '1'
      return post(`index/my_trace`, params)
    },
    my_user(params) {
      params.PCTOKEN = '1'
      return post(`index/my_user`, params)
    },
    // footer
    about(params) {
      params.PCTOKEN = '1'
      return post(`home/about`, params)
    },
    // 验证码获取
    getyzm(params) {
      params.PCTOKEN = '1'
      return post(`login/send_code`, params)
    },
    // 验证验证码
    ifcode(params) {
      params.PCTOKEN = '1'
      return post(`login/if_code`, params)
    },
    // 确认注册
    register(params) {
      params.PCTOKEN = '1'
      return post(`login/register`, params)
    },
    // 登录
    login(params) {
      params.PCTOKEN = '1'
      return post(`login/login`, params)
    },
    // 找回密码
    backpassword(params) {
      params.PCTOKEN = '1'
      return post(`login/back_password`, params)
    },
    // banner
    banner(params) {
      params.PCTOKEN = '1'
      return post(`home/banner`, params)
    },
    // 精品课程
    hot_list(params) {
      params.PCTOKEN = '1'
      return post(`home/hot_list`, params)
    },
    // 关于知会
    about_list(params) {
      params.PCTOKEN = '1'
      return post(`home/about_list`, params)
    },
    // 教研团队
    teacher_list(params) {
      params.PCTOKEN = '1'
      return post(`home/teacher_list`, params)
    },
    // 在线报名
    to_sign_up(params) {
      params.PCTOKEN = '1'
      return post(`home/to_sign_up`, params)
    },
    // 会员充值列表
    vip_price(params) {
      params.PCTOKEN = '1'
      return post(`home/vip_price`, params)
    },
    // 消息未读数量
    unread_count(params) {
      params.PCTOKEN = '1'
      return post(`index/unread_count`, params)
    },
    // 充值价格列表
    top_up_list(params) {
      params.PCTOKEN = '1'
      return post(`home/top_up_list`, params)
    },
    // 我的消息
    my_message(params) {
      params.PCTOKEN = '1'
      return post(`index/my_message`, params)
    },
    // 系统消息列表
    message_list(params) {
      params.PCTOKEN = '1'
      return post(`index/message_list`, params)
    },
    // 活动列表
    messageactivity_list(params) {
      params.PCTOKEN = '1'
      return post(`index/messageactivity_list`, params)
    },
    // 我的收藏
    my_coursecollect(params) {
      params.PCTOKEN = '1'
      return post(`index/my_coursecollect`, params)
    },
    // 我的团队
    team_user(params) {
      params.PCTOKEN = '1'
      return post(`index/team_user`, params)
    },
    // 我的团队/本月业绩
    day_mingxi(params) {
      params.PCTOKEN = '1'
      return post(`index/day_mingxi`, params)
    },
    // 成员动态
    teamdynamic_list(params) {
      params.PCTOKEN = '1'
      return post(`index/teamdynamic_list`, params)
    },
    // 课程详情
    course_detail(params) {
      params.PCTOKEN = '1'
      return post(`home/course_detail`, params)
    },
    // 课程评论列表
    evaluate_list(params) {
      params.PCTOKEN = '1'
      return post(`home/evaluate_list`, params)
    },
    // 添加评论
    add_evaluate(params) {
      params.PCTOKEN = '1'
      return post(`index/add_evaluate`, params)
    },
    // 课程分类
    course_type_list(params) {
      params.PCTOKEN = '1'
      return post(`home/course_type_list`, params)
    },
    // 精品课程列表
    good_course(params) {
      params.PCTOKEN = '1'
      return post(`home/good_course`, params)
    },
    // 课程列表(更多)
    course_list(params) {
      params.PCTOKEN = '1'
      return post(`home/course_list`, params)
    },
    // 更多推荐（课程）
    course_recommend(params) {
      params.PCTOKEN = '1'
      return post(`home/course_recommend`, params)
    },
    // 收藏课程
    collection(params) {
      params.PCTOKEN = '1'
      return post(`index/collection`, params)
    },
    // 阅读分类
    article_type(params) {
      params.PCTOKEN = '1'
      return post(`home/article_type`, params)
    },
    // 阅读名师推荐（PC）
    top_teacher(params) {
      params.PCTOKEN = '1'
      return post(`home/top_teacher`, params)
    },
    // 阅读列表
    article_list(params) {
      params.PCTOKEN = '1'
      return post(`home/article_list`, params)
    },
    // 阅读详情
    article_detail(params) {
      params.PCTOKEN = '1'
      return post(`home/article_detail`, params)
    },
    // 阅读点赞
    like_article(params) {
      params.PCTOKEN = '1'
      return post(`index/like_article`, params)
    },
    // 科研团队
    teacher_list(params) {
      params.PCTOKEN = '1'
      return post(`home/teacher_list`, params)
    },
    // 科研老师详情
    teacher_data(params) {
      params.PCTOKEN = '1'
      return post(`home/teacher_data`, params)
    },
    // 老师课程列表
    teacher_course_list(params) {
      params.PCTOKEN = '1'
      return post(`home/teacher_course_list`, params)
    },
    // 咨询分类
    consult_type_list(params) {
      params.PCTOKEN = '1'
      return post(`home/consult_type_list`, params)
    },
    // 咨询老师列表
    consult_teacher(params) {
      params.PCTOKEN = '1'
      return post(`home/consult_teacher`, params)
    },
    // 咨询老师详情
    teacher_detail(params) {
      params.PCTOKEN = '1'
      return post(`home/teacher_detail`, params)
    },
    // 新咨询
    consultform(params) {
      params.PCTOKEN = '1'
      return post(`index/consultform`, params)
    },
    // 测评分类
    appraisal_type_list(params) {
      params.PCTOKEN = '1'
      return post(`home/appraisal_type_list`, params)
    },
    // 精品测评
    daily_appraisal_list(params) {
      params.PCTOKEN = '1'
      return post(`home/daily_appraisal_list`, params)
    },
    // 测评列表
    appraisal_list(params) {
      params.PCTOKEN = '1'
      return post(`home/appraisal_list`, params)
    },
    // 测评详情
    appraisal_detail(params) {
      params.PCTOKEN = '1'
      return post(`home/appraisal_detail`, params)
    },
    // 开始测评
    pay_appraisal(params) {
      params.PCTOKEN = '1'
      return post(`index/pay_appraisal`, params)
    },
    // 个人中心我的课程
    my_course(params) {
      params.PCTOKEN = '1'
      return post(`index/my_course`, params)
    },
    // 个人中心我的评测
    my_appraisal(params) {
      params.PCTOKEN = '1'
      return post(`index/my_appraisal`, params)
    },
    // 个人中心我的咨询
    my_consult(params) {
      params.PCTOKEN = '1'
      return post(`index/my_consult`, params)
    },
    // 新个人中心我的咨询
    // user_consult(params) {
    //   params.PCTOKEN = '1'
    //   return post(`index/user_consult`, params)
    // },
    // 测评题目列表
    appraisal_content(params) {
      params.PCTOKEN = '1'
      return post(`index/appraisal_content`, params)
    },
    // 支付详情
    course_detail_pc(params) {
      params.PCTOKEN = '1'
      return post(`home/course_detail_pc`, params)
    },
    // 课程支付
    course_pay(params) {
      params.PCTOKEN = '1'
      return post(`index/course_pay`, params)
    },
    // 课程支付
    diaoqi(params) {
      params.PCTOKEN = '1'
      return post(`index/diaoqi`, params)
    },
    // 支付成功订单信息
    pay_succeed(params) {
      params.PCTOKEN = '1'
      return post(`index/pay_succeed`, params)
    },
    // 联系我们
    aboutpc(params) {
      params.PCTOKEN = '1'
      return post(`home/aboutpc`, params)
    },
    // 余额明细
    user_balance(params) {
      params.PCTOKEN = '1'
      return post(`index/user_balance`, params)
    },
    // 课程播放前请求
    pay_count(params) {
      params.PCTOKEN = '1'
      return post(`index/pay_count`, params)
    },
    // 播放停止后请求
    pay_time(params) {
      params.PCTOKEN = '1'
      return post(`index/pay_time`, params)
    },
    // 取消订单(课程)
    delete_order(params) {
      params.PCTOKEN = '1'
      return post(`index/delete_order`, params)
    },
    // 咨询支付
    consult_pay(params) {
      params.PCTOKEN = '1'
      return post(`index/consult_pay`, params)
    },
    // 取消订单(咨询)
    delete_consultmy(params) {
      params.PCTOKEN = '1'
      return post(`index/delete_consultmy`, params)
    },
    // 咨询支付详情（PC）
    zixun_detail(params) {
      params.PCTOKEN = '1'
      return post(`index/zixun_detail`, params)
    },
    // 修改密码
    edit_pwd(params) {
      params.PCTOKEN = '1'
      return post(`login/edit_pwd`, params)
    },
    // 保存 编辑个人资料
    edit_mydata(params) {
      params.PCTOKEN = '1'
      return post(`index/edit_mydata`, params)
    },
    // 回答测评题目
    user_answer(params) {
      params.PCTOKEN = '1'
      return post(`index/user_answer`, params)
    },
    // 取消订单（测评）
    delete_appraisal(params) {
      params.PCTOKEN = '1'
      return post(`index/delete_appraisal`, params)
    },
    // 测评结果查询
    appraisal_result(params) {
      params.PCTOKEN = '1'
      return post(`index/appraisal_result`, params)
    },
    // 各种协议
    agreement(params) {
      params.PCTOKEN = '1'
      return post(`home/agreement`, params)
    },
    // VIP充值
    vip_pay(params) {
      params.PCTOKEN = '1'
      return post(`index/vip_pay`, params)
    },
    // 充值
    top_up(params) {
      params.PCTOKEN = '1'
      return post(`index/top_up`, params)
    },
    // 订单是否支付
    if_pay(params) {
      params.PCTOKEN = '1'
      return post(`index/if_pay`, params)
    },
    // 提现申请
    withdrawal(params) {
      params.PCTOKEN = '1'
      return post(`index/withdrawal`, params)
    },
    // banner富文本
    banner_detail(params) {
      params.PCTOKEN = '1'
      return post(`home/banner_detail`, params)
    },
    //第三方链接
    link_data(params) {
      params.PCTOKEN = '1'
      return post(`home/link_data`, params)
    },
    //判断是否绑定微信
    my_wx(params) {
      params.PCTOKEN = '1'
      return post(`index/my_wx`, params)
    },
    //搜索课程列表
    search_course(params) {
      params.PCTOKEN = '1'
      return post(`home/search_course`, params)
    },
    //搜索测评列表
    search_appraisal(params) {
      params.PCTOKEN = '1'
      return post(`home/search_appraisal`, params)
    },
    //搜索老师
    search_teacher(params) {
      params.PCTOKEN = '1'
      return post(`home/search_teacher`, params)
    },
    //海报
    posters_list(params) {
      params.PCTOKEN = '1'
      return post(`home/posters_list`, params)
    },
    //扫码登陆
    loginscan(params) {
      params.PCTOKEN = '1'
      return post(`home/loginscan`, params)
    },
    //个人二维码
    my_code(params) {
      params.PCTOKEN = '1'
      return post(`index/my_code`, params)
    },
    //分享海报
    compound_posters(params) {
      params.PCTOKEN = '1'
      return post(`index/compound_posters`, params)
    },
    //绑定手机号
    bangding_phone(params) {
      params.PCTOKEN = '1'
      return post(`index/bangding_phone`, params)
    },
     //获取关键字
     getkeys(params) {
      params.PCTOKEN = '1'
      return post(`login/keyword`, params)
    },
      //友情链接
      blogroll(params) {
      params.PCTOKEN = '1'
      return post(`login/blogroll`, params)
    },
  }

}



// WEBPACK FOOTER //
// ./src/service/service.js